import PasskeyManager from "@/AUTH/PasskeyManager";


export default function SettingsPage() {
  return (
    <div className="max-w-2xl mx-auto p-4">
      <PasskeyManager />
    </div>
  );
}